import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { JEREMY, PHOTOS } from "@/lib/jeremy";

export default function MeetJeremy({ compact = false }) {
  return (
    <section className="py-20 md:py-28 bg-[#FDFBF7]" data-testid="meet-jeremy-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative">
            <div className="absolute -inset-4 bg-[#FEF3C7] rounded-[2rem] -rotate-2" />
            <div className="relative rounded-[1.75rem] overflow-hidden border border-[#E5E0D8] shadow-xl">
              <img
                src={PHOTOS.meet}
                alt="Jeremy — local Virginia solar guide"
                className="w-full h-[420px] md:h-[520px] object-cover"
                data-testid="meet-jeremy-photo"
              />
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <div className="eyebrow">Meet Jeremy</div>
          <h2 className="mt-3 font-serif-display text-3xl md:text-5xl font-semibold text-[#0F382C] leading-[1.1]">
            Solar can feel complicated. My job is to make it simple.
          </h2>
          <div className="mt-6 space-y-4 text-slate-600 leading-relaxed text-base md:text-lg">
            <p>
              Between utility rates, net metering, warranties, roof questions, and financing options, homeowners are often left trying to make sense of conflicting information.
            </p>
            {!compact && (
              <p>
                I'll review your electric bill, answer your questions honestly, and help you determine whether solar makes financial and practical sense for your home. If it does, I'll personally guide you through qualification, inspection, utility approval, permitting, installation, and final activation — with ION Solar handling the professional installation and long-term service.
              </p>
            )}
          </div>

          <div className="mt-8 grid sm:grid-cols-2 gap-2.5" data-testid="meet-jeremy-facts">
            {JEREMY.facts.map((f) => (
              <div key={f} className="flex items-start gap-2.5 text-sm text-[#0F382C]">
                <Sparkles className="w-4 h-4 text-[#D97706] shrink-0 mt-0.5" />
                <span>{f}</span>
              </div>
            ))}
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/meet-jeremy" className="btn-ghost-forest text-sm" data-testid="meet-jeremy-read-more">
              Read Jeremy's Story <ArrowRight className="w-4 h-4" />
            </Link>
            <Link to="/qualify?upload=1" className="btn-solar text-sm" data-testid="meet-jeremy-review-bill">
              Have Jeremy Review My Bill <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
